import { sumBy } from 'lodash';
import { IStore } from 'store/types';
import { DisbursementMethod, IPayoutStateByDate, IPayoutStateByParticipant, IPayoutStateByStatus, IPayoutStats, PayoutStatus } from 'types';

export const selectPayment = () => (state: IStore) => state.payment;

export const selectPaymentPayoutStats =
  () =>
  (state: IStore): IPayoutStats => {
    const { payment } = state;
    const instant = payment?.payouts.filter((p) => p.disbursementMethod === DisbursementMethod.INSTANT) || [];
    const payroll = payment?.payouts.filter((p) => p.disbursementMethod === DisbursementMethod.PAYROLL) || [];

    const byDate: IPayoutStateByDate[] = [];
    const net = payment?.totals.net;
    const gross = payment?.totals.gross;
    const holdbacks = payment?.totals.holdbacks;
    const autograts = payment?.totals.autoGratuities;
    const count = payment?.payouts.length || 0;
    const instantTotal = sumBy(instant, 'net');
    const payrollTotal = sumBy(payroll, 'net');

    byDate.push({ date: payment?.paymentDate, net, gross, count, holdbacks, instant: instantTotal, payroll: payrollTotal, autoGratuity: autograts });

    const byStatus: IPayoutStateByStatus[] = [];
    Object.values(PayoutStatus).forEach((status) => {
      const totals = (payment?.totals.status || []).find((s) => s.type.toLowerCase() === status);
      const instantByStatus = instant.filter((s) => s.type.toLowerCase() === status) || [];
      const instantTotal = sumBy(instantByStatus, 'net');
      const payrollByStatus = payroll.filter((s) => s.type.toLowerCase() === status) || [];
      const payrollTotal = sumBy(payrollByStatus, 'net');

      byStatus.push({ ...totals, instant: instantTotal, payroll: payrollTotal, status, autoGratuity: totals?.autoGratuities });
    });

    const byParticipant: IPayoutStateByParticipant[] = [];
    payment?.totals.participants.forEach((participant) => {
      if (!participant.totals) return;
      const { name, type } = participant;
      const { total, autoGratuities, tips } = participant.totals;

      byParticipant.push({ name, type, autoGratuities, tips, total, count: 1 });
    });

    return { byDate, byStatus, byParticipant };
  };
